export const sodas_brands = [
  "Coca Cola",
  "Coca Cola Zero",
  "Sprite",
  "Rojo",
  "Uva",
  "Merengue",
  "Naranja",
];

export const juice_flavors = ["CHINOLA", "CEREZA", "LIMON"];

export const drinks = [
  {
    id: "agua",
    key: "agua",
    title: "Agua",
    display: "AGUA",
    category: "bebida",
    price: 50,
    quantity: 0,
  },
  {
    id: "agua-con-gas",
    key: "agua-con-gas",
    title: "Agua con gas",
    display: "AGUA CON GAS",
    category: "bebida",
    price: 90,
    quantity: 0,
  },
  {
    id: "Coca Cola",
    key: "refresco",
    title: "Coca Cola",
    display: "REFRESCO",
    category: "bebida",
    price: 90,
    quantity: 0,
  },
  {
    id: "CHINOLA",
    key: "jugo",
    title: "CHINOLA",
    display: "JUGO",
    category: "bebida",
    price: 160,
    quantity: 0,
  },
  // {
  //   id: 'redbull',
  //   key: 'redbull',
  //   title: 'Redbull',
  //   display: 'REDBULL',
  //   category: 'bebida',
  //   price: 100,
  //   quantity: 0
  // },
  // {
  //   id: 'cerveza',
  //   key: 'cerveza',
  //   title: 'Cerveza',
  //   display: 'CERVEZA',
  //   category: 'bebida',
  //   price: 150,
  //   quantity: 0
  // },
  {
    id: "cerveza-modelo",
    key: "cerveza",
    title: "cerveza HEINEKEN 650ml Grande",
    display: "CERVEZA HEINEKEN 650ML GRANDE",
    category: "bebida",
    price: 475,
    quantity: 0,
  },
  {
    id: "cerveza-presidente",
    key: "cerveza-presidente",
    title: "Cerveza Presidente 650ml Grande",
    display: "CERVEZA PRESIDENTE 650ML GRANDE",
    category: "bebida",
    price: 450,
    quantity: 0,
  },
];

// export const refrescos = [
//   'Coca Cola',
//   'Coca Cola Light',
//   'Sprite',
//   'Rojo',
//   'Uva',
//   'Merengue',
//   'Fanta',
// ]

export const desserts = [
  // {
  //   id: "flan",
  //   key: "flan",
  //   title: "Flan",
  //   display: "FLAN",
  //   category: "postre",
  //   price: 125,
  //   quantity: 0,
  // },
  // {
  //   id: "brownieTwix",
  //   key: "brownieTwix",
  //   title: "Brownie Twix",
  //   display: "BROWNIE TWIX",
  //   category: "postre",
  //   price: 150,
  //   quantity: 0,
  // },
  {
    id: "brownieTwix",
    key: "brownieTwix",
    display: "BROWNIE",
    title: "Brownie",
    category: "postre",
    price: 125,
    quantity: 0,
  },
  {
    id: "cookie",
    key: "cookie",
    title: "Galletitas de Pistacho “YoSoyFrank”",
    display: "GALLETITAS DE PISTACHO “YOSOYFRANK”",
    category: "postre",
    price: 225,
    quantity: 0,
  },
  {
    id: "nutellaCake",
    key: "nutellaCake",
    title: "Lime Cheesecake",
    display: "LIME CHEESECAKE",
    category: "postre",
    price: 250,
    quantity: 0,
  },
  {
    id: "blondie",
    key: "blondie",
    title: "Blondie",
    display: "BLONDIE",
    category: "postre",
    price: 275,
    quantity: 0,
  },
  {
    id: "tresleches",
    key: "tresleches",
    title: "Tres Leches (grande)",
    display: "TRES LECHES (GRANDE)",
    category: "postre",
    price: 395,
    quantity: 0,
    imageHeight: 95,
    imageWidth: 95,
  },
  // {
  //   id: 'nutellaCake',
  //   key: 'nutellaCake',
  //   display: 'NUTELLA CAKE',
  //   title: 'Nutella Cake',
  //   category: 'postre',
  //   price: 200,
  //   quantity: 0
  // },
  // {
  //   id: 'tresleches',
  //   key: 'tresleches',
  //   display: 'TRES LECHES',
  //   title: 'Tres Leche',
  //   category: 'postre',
  //   price: 250,
  //   quantity: 0
  // },
];
